if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.yumi-product-gallery');

  if (!gallery) return;

  /*
   * -----------------------------------------
   * GET PRODUCT VARIANTS
   * -----------------------------------------
   */
  function getVariants() {
    const variantScript = document.querySelector(
      'script[type="application/json"][data-variant]'
    );

    if (!variantScript) {
      console.warn('Variant JSON not found.');
      return [];
    }

    try {
      return JSON.parse(variantScript.textContent);
    } catch (error) {
      console.error('Could not parse variant JSON', error);
      return [];
    }
  }

  /*
   * -----------------------------------------
   * GET SELECTED VARIANT
   * -----------------------------------------
   */
  function getSelectedVariant() {
    const variants = getVariants();

    if (!variants.length) return null;

    const selectedOptions = [];

    /*
     * Get only Shopify variant picker radios
     */
    const radios = document.querySelectorAll(
      'variant-radios input[type="radio"]:checked'
    );

    radios.forEach(radio => {
      selectedOptions.push(
        String(radio.value).trim()
      );
    });

    /*
     * Get Shopify variant select values
     */
    const selects = document.querySelectorAll(
      'variant-selects select'
    );

    selects.forEach(select => {
      selectedOptions.push(
        String(select.value).trim()
      );
    });

    if (!selectedOptions.length) {
      return null;
    }

    /*
     * Find matching Shopify variant
     */
    return variants.find(variant => {
      if (!variant.options) return false;

      return variant.options.every(
        (option, index) =>
          String(option).trim() ===
          String(selectedOptions[index] || '').trim()
      );
    }) || null;
  }

  /*
   * -----------------------------------------
   * GET VARIANT GROUP
   * -----------------------------------------
   *
   * Color = option1
   *
   * If Color is option2, change:
   * variant.option1
   * to:
   * variant.option2
   */
  function getVariantGroup(variant) {
    if (!variant) return '';

    return String(
      variant.option1 || ''
    )
      .trim()
      .toLowerCase();
  }

  /*
   * -----------------------------------------
   * SHOW ALL MEDIA
   * -----------------------------------------
   *
   * This is used ONLY on initial page load.
   */
  function showAllMedia() {
    const slides = gallery.querySelectorAll(
      '.yumi-product-gallery__slide'
    );

    slides.forEach(slide => {
      slide.classList.remove(
        'variant-hidden'
      );
    });

    const thumbnails = gallery.querySelectorAll(
      '.yumi-product-gallery__thumb'
    );

    thumbnails.forEach(thumbnail => {
      thumbnail.classList.remove(
        'variant-hidden'
      );
    });
  }

  /*
   * -----------------------------------------
   * FILTER GALLERY
   * -----------------------------------------
   */
  function filterGallery() {
    const variant = getSelectedVariant();

    if (!variant) {
      return;
    }

    const variantGroup =
      getVariantGroup(variant);

    if (!variantGroup) {
      return;
    }

    console.log(
      'Selected variant:',
      variant
    );

    console.log(
      'Selected image group:',
      variantGroup
    );

    const slides = gallery.querySelectorAll(
      '.yumi-product-gallery__slide'
    );

    const thumbnails = gallery.querySelectorAll(
      '.yumi-product-gallery__thumb'
    );

    const visibleSlides = [];

    /*
     * -----------------------------------------
     * FILTER MAIN IMAGES
     * -----------------------------------------
     */
    slides.forEach(slide => {

      const mediaAlt = String(
        slide.getAttribute(
          'data-media-alt'
        ) || ''
      )
        .trim()
        .toLowerCase();

      const shouldShow =
        mediaAlt === variantGroup;

      slide.classList.toggle(
        'variant-hidden',
        !shouldShow
      );

      if (shouldShow) {
        visibleSlides.push(slide);
      }
    });

    /*
     * -----------------------------------------
     * FILTER THUMBNAILS
     * -----------------------------------------
     */
    thumbnails.forEach(thumbnail => {

      const mediaAlt = String(
        thumbnail.getAttribute(
          'data-media-alt'
        ) || ''
      )
        .trim()
        .toLowerCase();

      const shouldShow =
        mediaAlt === variantGroup;

      thumbnail.classList.toggle(
        'variant-hidden',
        !shouldShow
      );
    });

    /*
     * -----------------------------------------
     * ACTIVATE VARIANT FEATURED IMAGE
     * -----------------------------------------
     */
    let mediaToActivate = null;

    if (
      variant.featured_media &&
      variant.featured_media.id
    ) {

      const featuredId =
        String(
          variant.featured_media.id
        );

      const featuredSlide =
        gallery.querySelector(
          `.yumi-product-gallery__slide[data-media-id="${featuredId}"]`
        );

      if (
        featuredSlide &&
        !featuredSlide.classList.contains(
          'variant-hidden'
        )
      ) {
        mediaToActivate =
          featuredId;
      }
    }

    /*
     * -----------------------------------------
     * IF FEATURED IMAGE IS NOT IN GROUP,
     * USE FIRST IMAGE OF SELECTED GROUP
     * -----------------------------------------
     */
    if (
      !mediaToActivate &&
      visibleSlides.length
    ) {
      mediaToActivate =
        visibleSlides[0].getAttribute(
          'data-media-id'
        );
    }

    if (mediaToActivate) {
      activateMedia(
        mediaToActivate
      );
    }
  }

  /*
   * -----------------------------------------
   * ACTIVATE MEDIA
   * -----------------------------------------
   */
  function activateMedia(mediaId) {

    const slides = gallery.querySelectorAll(
      '.yumi-product-gallery__slide'
    );

    slides.forEach(slide => {

      const active =
        String(
          slide.getAttribute(
            'data-media-id'
          )
        ) === String(mediaId);

      slide.classList.toggle(
        'is-active',
        active
      );
    });

    const thumbnails = gallery.querySelectorAll(
      '.yumi-product-gallery__thumb'
    );

    thumbnails.forEach(thumbnail => {

      const active =
        String(
          thumbnail.getAttribute(
            'data-media-id'
          )
        ) === String(mediaId);

      thumbnail.classList.toggle(
        'is-active',
        active
      );

      if (active) {
        thumbnail.setAttribute(
          'aria-current',
          'true'
        );

        thumbnail.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      } else {
        thumbnail.removeAttribute(
          'aria-current'
        );
      }
    });

    /*
     * Update zoom image
     */
    const activeSlide =
      gallery.querySelector(
        `.yumi-product-gallery__slide[data-media-id="${mediaId}"]`
      );

    const zoomImage =
      document.querySelector(
        '#yumiZoomImg'
      );

    if (
      activeSlide &&
      zoomImage
    ) {

      const image =
        activeSlide.querySelector('img');

      if (image) {
        zoomImage.src =
          image.currentSrc ||
          image.src;
      }
    }
  }

  /*
   * -----------------------------------------
   * VARIANT RADIO CHANGE
   * -----------------------------------------
   */
  document.addEventListener(
    'change',
    event => {

      if (
        event.target.matches(
          'variant-radios input[type="radio"]'
        )
      ) {

        setTimeout(
          filterGallery,
          100
        );
      }

      if (
        event.target.matches(
          'variant-selects select'
        )
      ) {

        setTimeout(
          filterGallery,
          100
        );
      }
    }
  );

  /*
   * -----------------------------------------
   * SHOPIFY VARIANT CHANGE
   * -----------------------------------------
   */
  document.addEventListener(
    'variant:change',
    () => {

      setTimeout(
        filterGallery,
        100
      );
    }
  );

  /*
   * -----------------------------------------
   * IMPORTANT:
   *
   * DO NOT call filterGallery() here.
   *
   * Show all images on initial load.
   * -----------------------------------------
   */
  showAllMedia();
});